<template>
  <div class="mb-2 pt-2">
    <v-card>
      <v-tabs
        background-color="colorDominant colorTabs"
        show-arrows
        height="48px"
        v-model="activeTab"
        class="fixed-tabs"
      >
        <template v-for="(tab, i) in tabs">
          <v-tab
            class="overline white--text"
            :key="i"
            @click="$router.push({ name: tab.routeName, hash: '#scrollTop' })"
          >
            {{ tab.name }}
          </v-tab>
        </template>
      </v-tabs>
    </v-card>
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  name: "myBets",
  data() {
    return {
      activeTab: null,
    };
  },
  computed: {
    operatorCashout() {
      return this.$store.state.operators.cashout;
    },
    tabs() {
      const items = [
        {
          name: `${this.$t("pending")}`,
          routeName: "pendentsBets",
        },
        {
          name: `${this.$t("closeBet")}`,
          routeName: "closeBets",
        },
        {
          name: `${this.$t("live")}`,
          routeName: "liveBets",
        },
        {
          name: `${this.$t("resolved")}`,
          routeName: "resolvedBets",
        },
        {
          name: `${this.$t("bonus")}`,
          routeName: "bonusBets",
        },
        {
          name: `${this.$t("all")}`,
          routeName: "allBets",
        },
      ];

      // Cenário 1 - Sem cashout e Sem crédito online
      if (this.operatorCashout == "0" && !this.$isCreditOnline()) {
        var only = ["pendentsBets", "resolvedBets", "allBets"];
        var filtered = items.filter(function (item) {
          return only.includes(item.routeName);
        });
        return filtered;
      }

      // Cenário 2 - Sem cashout e com Crédito Online
      if (this.operatorCashout == "0" && this.$isCreditOnline()) {
        var only = ["pendentsBets", "resolvedBets", "bonusBets", "allBets"];
        var filtered = items.filter(function (item) {
          return only.includes(item.routeName);
        });
        return filtered;
      }

      return items;
    },
  },
  mounted() {
    // Set Active Tab
    this.tabs.forEach((tab, i) => {
      if (tab.routeName === this.$route.name) {
        this.activeTab = i;
      }
    });
  },
  watch: {
    $route(val) {
      // Set Active Tab
      this.tabs.forEach((tab, i) => {
        if (tab.routeName === val.name) {
          this.activeTab = i;
        }
      });
    },
  },
};
</script>
